export default __webpack_public_path__ + "static/media/018-magnetic field.a7096ccf.svg";